import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

import {
  RouterService,
  StateService,
  ViewerComponent,
} from 'projects/shared/src/public-api';

@Component({
  selector: 'app-construction-site',
  templateUrl: './construction-site.component.html',
  styleUrls: ['./construction-site.component.scss'],
  standalone: false,
})
export class ConstructionSiteComponent implements OnInit {
  constructor(
    public state: StateService,
    public routerService: RouterService,
    public modalController: ModalController
  ) {}
  ngOnInit() {}

  handleRefresh(event: any) {
    this.state.loadNodeItems().subscribe((x) => {
      event.target.complete();
    });
  }
}
